import { Stack, Typography } from '@mui/material';
import React from 'react';
import UserContext from '../../../context/userContext';
import {
	ADMIN_ACCOUNT_DETAILS_HEADER,
	EMAIL_LABEL,
	NAME_LABEL,
	USERNAME_LABEL,
} from '../../../data/labelsAndMessages';

interface UserInfo {
	title: string;
	data: string;
}

const AdministrationAccountDetails = () => {
	const { user } = React.useContext(UserContext);
	const name = user.firstName + ' ' + user.lastName;
	const username = user.username;
	const email = user.email;

	const UserInfoComponent = () => {
		const userInfoArray: UserInfo[] = [
			{
				title: NAME_LABEL(),
				data: name,
			},
			{
				title: USERNAME_LABEL(),
				data: username,
			},
			{
				title: EMAIL_LABEL(),
				data: email,
			},
		];

		return (
			<Stack direction='row' spacing={4}>
				{userInfoArray.map((info: UserInfo, index) => {
					return (
						<div key={index}>
							<Typography variant='body1'>{info.title}</Typography>
							<Typography variant='body1' sx={{ fontWeight: 'medium' }}>
								{info.data}
							</Typography>
						</div>
					);
				})}
			</Stack>
		);
	};

	return (
		<Stack spacing={3}>
			<Typography variant='h3' sx={{ fontWeight: 'medium', mt: 0.5 }}>
				{ADMIN_ACCOUNT_DETAILS_HEADER()}
			</Typography>
			<UserInfoComponent />
		</Stack>
	);
};

export default AdministrationAccountDetails;
